
import { useMemo } from "react";
import { MRT_ColumnDef } from "material-react-table";
import { IPreventaCorporativo } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { formatDate } from "@/shared";

const useColumnsOportunidadComercial = () => {
      ///* Hook
    const columnsPreventaCorporativo = useMemo<MRT_ColumnDef<IPreventaCorporativo>[]>(() => [
        {
          accessorKey: 'razon_social',
          header: 'Razon social',
          Cell: ({ row }) => row.original?.prospecto_corporativo_data?.razon_social || "N/A",
          size: 400,
        },
        {
          accessorKey: 'identificacion',
          header: 'Identificacion',
          Cell: ({ row }) => row.original?.prospecto_corporativo_data?.identificacion || "N/A"
        },
        {
          accessorKey: 'tipo_plan',
          header: 'Tipo Servicio',
          enableColumnFilter:false,
          // filterVariant: 'select',
          // filterSelectOptions: TIPO_PLAN_CORPORATIVO_CHOICE,
          Cell: ({ row }) => row.original?.data_plan_personalizado?.tipo_plan_personalizado
        },
        {
          accessorKey: 'plan_data.nombre',
          enableColumnFilter:false,
          header: 'Nombre Enlace',
          Cell: ({ row }) => row.original?.data_plan_personalizado?.nombre_personalizado
        },
        {
          accessorKey: 'prospecto_corporativo_data.user_create',
          enableColumnFilter:false,
          header: 'asesor',
          Cell: ({ row }) => row.original?.prospecto_corporativo_data?.user_create || "N/A"
        },
        {
          accessorKey: 'fecha_creacion',
          header: 'Fecha Creación',
          Cell: ({ row }) => formatDate(row.original.fecha_creacion!),
          enableColumnFilter:false,
        },
        {
          accessorKey: 'fecha_modificacion',
          header: 'Fecha Modificación',
          Cell: ({ row }) => formatDate(row.original.fecha_modificacion!),
          enableColumnFilter:false,
        },
    
    ], []);


  return {
    columnsPreventaCorporativo,
  }
}

export default useColumnsOportunidadComercial